import { Stack, Typography } from "@mui/material";
import { useOutletContext, useParams } from "react-router-dom";
import { Step } from "@/pages/checkout/hooks/useCheckoutSteps";
import SummaryPanel from "@/pages/checkout/components/ConfirmationView/components/SummaryPanel";
import StepSummary from "@/pages/checkout/components/ConfirmationView/components/StepSummary";
import { useAppSelector } from "@/hooks";
import useRoutes from "@/hooks/useRoutes";
import { getOrderDetails, getOrderItemPrice, getOrderSubtotal, getOrderTaxes, getOrderTotal } from "@/utils/order";
import { RootState } from "@/store/store";
import DataCell from "@/components/DataCell";
import { addCurrency } from "@/utils/numbers";
import useServiceFee from "@/hooks/useServiceFee";
import Price from "@/components/Price";

const ConfirmationView = () => {
  const [navigate] = useRoutes();
  const service = useServiceFee();
  const { steps } = useOutletContext<{ steps: Step[] }>();
  const order = useAppSelector((state: RootState) => {
    return state.order;
  });
  const { orderId } = useParams<{ orderId: string }>();

  const organizationId = useAppSelector((state) => state.ui.activeOrganization);
  const organization = useAppSelector((state) => state.organizations[organizationId]);

  return (
    <Stack spacing={1}>
      <SummaryPanel title="¿Qué recibirás?" onEdit={() => navigate("organizations.menu.main", { orderId: orderId || "" })} error={!order?.items?.length ? "Información incompleta" : undefined}>
        {order?.items?.map((item: any) => (
          <Stack key={item.id} spacing={2} direction={"row"}>
            <Stack flex={1}>
              <Typography>
                {item.quantity} - {item.title}
              </Typography>
              <Typography variant="body1">{getOrderDetails(item)}</Typography>
            </Stack>
            <Stack>
              <Typography>{<Price currency="NIO">{getOrderItemPrice(item)}</Price>}</Typography>
            </Stack>
          </Stack>
        ))}
      </SummaryPanel>

      {steps.map((step) => (
        <StepSummary step={step} key={step.id} />
      ))}

      <SummaryPanel title="Resumen de costos">
        <Stack spacing={1}>
          <DataCell label="Subtotal" value={<Price currency="NIO">{getOrderSubtotal(order.items)}</Price>} />

          {order.flow === "delivery" && service.fee ? (
            <DataCell label="Envío" value={<Price currency="NIO">{service.fee}</Price>} />
          ) : order.flow === "delivery" && service.type === "manual" ? (
            <DataCell label="Envío" value="A convenir" />
          ) : null}

          {order?.taxes && organization?.settings?.includeTax ? (
            <DataCell label="IVA" value={<Price currency="NIO">{addCurrency(getOrderTaxes(order.items) as unknown as string, "NIO")}</Price>} />
          ) : null}

          <DataCell label="Total" value={<Price currency="NIO">{getOrderTotal(order.items, organization?.settings?.includeTax, service.fee)}</Price>} />
        </Stack>
      </SummaryPanel>
    </Stack>
  );
};

export default ConfirmationView;
